module.exports = __webpack_public_path__ + "img/eldac_white.401533f3.png";